import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type GetUserInfoStatus = {
  userInfoLoadSuccess?: boolean;
  error?: Error;
};

type UserInfoLoadState = GetUserInfoStatus & {
  hasEverLoaded: boolean;
};

const initialState: UserInfoLoadState = { hasEverLoaded: false };

const getUserInfoStatusSlice = createSlice({
  name: 'getUserInfoStatus',
  initialState,
  reducers: {
    loadUserInfo: state => {
      state.userInfoLoadSuccess = undefined;
      state.error = undefined;
    },
    userInfoLoaded: (state, action: PayloadAction<GetUserInfoStatus>) => {
      state.userInfoLoadSuccess = action.payload.userInfoLoadSuccess;
      state.error = action.payload.error;
      if (action.payload.userInfoLoadSuccess) {
        state.hasEverLoaded = true;
      }
    },
  },
});

export const { loadUserInfo, userInfoLoaded } = getUserInfoStatusSlice.actions;

export default getUserInfoStatusSlice.reducer;
